/**
 *  @author => @RMT_FRONT_CORE/CLI
 * */
import React from 'react';
import { Redirect } from 'react-router-dom';
import settings from 'config/constants';

const SuspiciousRegistrationReport = React.lazy(() => import('./views/pages/SuspiciousRegistrationReport'));
const PlayerCheckHistoryReports = React.lazy(() => import('./views/pages/PlayerCheckHistoryReports'));
const PlayerBlockStatusReports = React.lazy(() => import('./views/pages/PlayerBlockStatusReports'));
const MultiAccountGroupReport = React.lazy(() => import('./views/pages/MultiAccountGroupReport'));
const UserPlayerReports = React.lazy(() => import('./views/pages/UserPlayerReports'));
const LoginIPReports = React.lazy(() => import('./views/pages/LoginIPReports'));
const AlertReports = React.lazy(() => import('./views/pages/AlertReports'));
const AlertIdsReport = React.lazy(() => import('./views/pages/AlertIdsReport'));
const BetsReports = React.lazy(() => import('./views/pages/BetsReports'));

const subUrl = settings.PRODUCTS.RMT.path;

type Route = {
  path: string,
  name: string,
  exact: boolean,
  page: Function,
  subRoutes?: Array<Route>,
}

const ROUTES: Array<Route> = [
  { path: `/${subUrl}/reports`, name: 'Reports', exact: true, page: () => <Redirect to={`/${subUrl}/reports/bets-reports`} /> },
  { path: `/${subUrl}/reports/bets-reports`, name: 'Bets Reports', exact: true, page: BetsReports },
  { path: `/${subUrl}/reports/user-player-reports`, name: 'User-Player Reports', exact: true, page: UserPlayerReports },
  { path: `/${subUrl}/reports/alert-reports`, name: 'Alert Reports', exact: true, page: AlertReports },
  { path: `/${subUrl}/reports/alert-ids-report`, name: 'Alert IDs Report', exact: true, page: AlertIdsReport },
  { path: `/${subUrl}/reports/player-block-status-reports`, name: 'Player Block Status Reports', exact: true, page: PlayerBlockStatusReports },
  { path: `/${subUrl}/reports/player-check-history-reports`, name: 'Player Check History Reports', exact: true, page: PlayerCheckHistoryReports },
  { path: `/${subUrl}/reports/login-ip-reports`, name: 'Login Ip Reports', exact: true, page: LoginIPReports },
  { path: `/${subUrl}/reports/suspicious-registration-report`, name: 'Suspicious Registration Report', exact: true, page: SuspiciousRegistrationReport },
  { path: `/${subUrl}/reports/multi-account-group-report`, name: 'Multi Account Group Report', exact: true, page: MultiAccountGroupReport }
];

export default ROUTES;
